import { Page, Text } from '@/ui-kit'

export function Page404(): JSX.Element {
  return (
    <Page className="items-center justify-center">
      <Text type="h1">404</Text>
      <Text type="h2">Page not found</Text>
    </Page>
  )
}
